 $.fn.isInViewport = function() {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();

  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  return elementBottom > viewportTop && elementTop < viewportBottom;
};

// Allow for Query Strings

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

/*!
 * jQuery Cookie Plugin v1.4.1
 * https://github.com/carhartl/jquery-cookie
 *
 * Copyright 2006, 2014 Klaus Hartl
 * Released under the MIT license
 */
(function (factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD (Register as an anonymous module)
        define(['jquery'], factory);
    } else if (typeof exports === 'object') {
        // Node/CommonJS
        module.exports = factory(require('jquery'));
    } else {
        // Browser globals
        factory(jQuery);
    }
}(function ($) {

    var pluses = /\+/g;

    function encode(s) {
        return config.raw ? s : encodeURIComponent(s);
    }

    function decode(s) {
        return config.raw ? s : decodeURIComponent(s);
    }

    function stringifyCookieValue(value) {
        return encode(config.json ? JSON.stringify(value) : String(value));
    }

    function parseCookieValue(s) {
        if (s.indexOf('"') === 0) {
            // This is a quoted cookie as according to RFC2068, unescape...
            s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
        }

        try {
            // Replace server-side written pluses with spaces.
            // If we can't decode the cookie, ignore it, it's unusable.
            // If we can't parse the cookie, ignore it, it's unusable.
            s = decodeURIComponent(s.replace(pluses, ' '));
            return config.json ? JSON.parse(s) : s;
        } catch(e) {}
    }

    function read(s, converter) {
        var value = config.raw ? s : parseCookieValue(s);
        return $.isFunction(converter) ? converter(value) : value;
    }

    var config = $.cookie = function (key, value, options) {

        // Write

        if (arguments.length > 1 && !$.isFunction(value)) {
            options = $.extend({}, config.defaults, options);

            if (typeof options.expires === 'number') {
                var days = options.expires, t = options.expires = new Date();
                t.setMilliseconds(t.getMilliseconds() + days * 864e+5);
            }

            return (document.cookie = [
                encode(key), '=', stringifyCookieValue(value),
                options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
                options.path    ? '; path=' + options.path : '',
                options.domain  ? '; domain=' + options.domain : '',
                options.secure  ? '; secure' : ''
            ].join(''));
        }

        // Read

        var result = key ? undefined : {},
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all. Also prevents odd result when
            // calling $.cookie().
            cookies = document.cookie ? document.cookie.split('; ') : [],
            i = 0,
            l = cookies.length;

        for (; i < l; i++) {
            var parts = cookies[i].split('='),
                name = decode(parts.shift()),
                cookie = parts.join('=');

            if (key === name) {
                // If second argument (value) is a function it's a converter...
                result = read(cookie, value);
                break;
            }

            // Prevent storing a cookie that we couldn't decode.
            if (!key && (cookie = read(cookie)) !== undefined) {
                result[name] = cookie;
            }
        }

        return result;
    };

    config.defaults = {};

    $.removeCookie = function (key, options) {
        // Must not alter options, thus extending a fresh object...
        $.cookie(key, '', $.extend({}, options, { expires: -1 }));
        return !$.cookie(key);
    };

}));


$(document).ready(function() {

	setTimeout(function() {
		jQuery.getJSON('/cart.js', function(cart) {
		$('#CartCount').text(cart.item_count);
		} );
	}, 150);
	

	// Variables

	var win = $(window),
	body = $('body'),
	logo = $('.site-header__logo');




	// Detect when user is at bottom of page to move logo up

	$(window).scroll(function(){
	    if ($(window).scrollTop() == $(document).height()-$(window).height()){
	        logo.addClass('pushed');
            $('.site-credit').addClass('pushed');
	    } else {
	    	logo.removeClass('pushed');
            $('.site-credit').removeClass('pushed');
	    }	
	});




	// Escape Key

	$(document).keyup(function(e) {
	  if (e.keyCode === 27){
	  	if(body.hasClass('js-drawer-open')){
	  		body.removeClass('js-drawer-open js-drawer-open-left js-drawer-open-right search-open account-open');
	  		$('html').removeClass('js-drawer-open js-drawer-open-left js-drawer-open-right');
	  		$('html').removeClass('js-drawer-open js-drawer-open-left js-drawer-open-right');
	  		$('#NavDrawer').removeAttr('tabindex');
	  		$('.klevu-pt-rs-hover').hide();
	  		evt.preventDefault();
	  		return false;	
	  	}
	  }
	});




	// Page Transitions

	$(".animsition").animsition({
	    inClass: 'fade-in',
	    outClass: 'fade-out',
	    inDuration: 250,
	    outDuration: 250,
	    linkElement: '.animsition-link',
	    // e.g. linkElement: 'a:not([target="_blank"]):not([href^="#"])'
	    loading: false,
	    loadingParentElement: 'body', //animsition wrapper element
	    loadingClass: 'animsition-loading',
	    loadingInner: '', // e.g '<img src="loading.svg" />'
	    timeout: false,
	    timeoutCountdown: 2500,
	    onLoadEvent: true,
	    browser: [ 'animation-duration', '-webkit-animation-duration'],
	    // "browser" option allows you to disable the "animsition" in case the css property in the array is not supported by your browser.
	    // The default setting is to disable the "animsition" in a browser that does not support "animation-duration".
	    overlay : false,
	    overlayClass : 'animsition-overlay-slide',
	    overlayParentElement : 'body',
	    transition: function(url){ window.location.href = url; }
	  });




	// Navigation

	$( "li.top-tier" ).hover(
	  function() {

	  	if ($(this).hasClass('site-nav--has-dropdown')){
			body.addClass('nh');
			var $this = $(this);
			setTimeout(function() {
				$this.children('ul').addClass('active');
			}, 150);
		}
		$(this).siblings().addClass('nh');
	    
	  }, function() {
	    $(this).siblings().removeClass('nh');
	    $(this).children().removeClass('active');
	    body.removeClass('nh');
	  }
	);




	// Mobile Navigation

	logo.click(function (evt) {
		if(body.hasClass('js-drawer-open')){
			body.removeClass('js-drawer-open js-drawer-open-left js-drawer-open-right account-open search-open');
			$('html').removeClass('js-drawer-open js-drawer-open-left js-drawer-open-right');
			$('html').removeClass('js-drawer-open js-drawer-open-left js-drawer-open-right');
			$('#NavDrawer').removeAttr('tabindex');
			evt.preventDefault();
			return false;	
		}
		
	});




	// Search Icons

	$(".search-link, a[href='#search'], .search-icon").click(function (evt) {
		body.removeClass('account-open js-drawer-open-left js-drawer-open-right');
		$('html').removeClass('js-drawer-open js-drawer-open-left js-drawer-open-right');
		$('html').removeClass('js-drawer-open js-drawer-open-left js-drawer-open-right');
		if(body.hasClass('js-drawer-open')){
			body.removeClass('js-drawer-open search-open');
		} else {
			body.addClass('js-drawer-open search-open');
		}
		$('#search').focus();
		evt.preventDefault();
		return false;
	});

			$("body.search-open .main-content").click(function (evt) {
				$('html').removeClass('js-drawer-open-left js-drawer-open-right');
				$('.klevu-pt-rs-hover').hide();
				body.removeClass('js-drawer-open js-drawer-open-left js-drawer-open-right search-open');
				body.removeClass('account-open');
				$('html').removeClass('js-drawer-open js-drawer-open-left js-drawer-open-right');
				$('html').removeClass('js-drawer-open js-drawer-open-left js-drawer-open-right');
				evt.preventDefault();
				return false;
			});


	// Search Icons

	$(".account-link").click(function (evt) {

		if(body.hasClass('customer-logged-in')){

		} else {

			body.removeClass('search-open js-drawer-open-left js-drawer-open-right');
			$('html').removeClass('js-drawer-open js-drawer-open-left js-drawer-open-right');
			$('html').removeClass('js-drawer-open js-drawer-open-left js-drawer-open-right');

			if(body.hasClass('js-drawer-open')){
				body.removeClass('js-drawer-open account-open');
			} else {
				body.addClass('js-drawer-open account-open');
			}


			evt.preventDefault();
			return false;

		}

	});

	$(".backing").click(function (evt) {

		if(body.hasClass('js-drawer-open')){
			body.removeClass('js-drawer-open js-drawer-open-left js-drawer-open-right search-open account-open');
			$('html').removeClass('js-drawer-open js-drawer-open-left js-drawer-open-right');
			$('html').removeClass('js-drawer-open js-drawer-open-left js-drawer-open-right');
			$('#NavDrawer').removeAttr('tabindex');

			evt.preventDefault();
			return false;	
		}
		$('.klevu-pt-rs-hover').hide();
		evt.preventDefault();
		return false;
	});



	// Audio Controls in header

	// var widget = SC.Widget(document.getElementById('soundcloud_widget'));
	
	// widget.bind(SC.Widget.Events.READY, function() {
	//   console.log('Ready...');
	  
	// });

	// $('#audio-toggle').click(function() {
	//   //widget.toggle();
	//   //console.log(widget);
	//   widget.isPaused(function(pause){
	//     console.log(pause);
	//     if (pause == false){
	//       console.log('pause');
	//       widget.pause();
	//     }else{
	//       console.log('play');
	//       widget.play();
	//     }
	//   });
	  
	// });


	if (body.hasClass('template-index')){
		$('#hello').focus();
	}

	$("#app-modal .close").click(function (evt) {

		$(this).closest('#app-modal').fadeOut();	
		$.cookie('UNIF_app', 'dismissed', { expires: 1, path: '/' });
		evt.preventDefault();
		return false;
	});

		if ($.cookie('UNIF_app') == null) {
	      	setTimeout(function(){
	    		$("#app-modal").fadeIn();
	    	}, 1000);
		}



	// Special Collection Pages


	if (body.hasClass('template-collection-special')){

		var $grid = $('.grid--special').isotope({
			itemSelector: '.ii',
			masonry: {
			    columnWidth: '.ii'
			  }
		});

		$grid.imagesLoaded().progress( function() {
		  $grid.isotope('layout');
		});

	}





	// Product Page

	if (body.hasClass('template-product')){


		// Hide Shop The Feed if it doesn't exist

		setTimeout(function() {
			if ( $( ".fs-timeline-entry" ).length ) {
			    $('.shop-the-feed .major-heading').show();
			} else {
				$('.shop-the-feed .major-heading').hide();
			}
		}, 10000);


		// Assign Background Color
		$.adaptiveBackground.run();
		var mainImg = $('#product-test');
      	var mainImgb = $('#product-test-alternate img');

		mainImg.on('ab-color-found', function(e, data){
			$('.product-single').css('background', data.color);
			$('.major-heading, .form-grid button').css('color', data.color);
			$('.form-grid button span').css('border-color', data.color);
			$('.shop-the-look-grid').css('background-color', data.color);
	    });
      
      mainImgb.on('ab-color-found', function(e, data){
			$('.product-single').css('background', data.color);
			$('.major-heading, .form-grid button').css('color', data.color);
			$('.form-grid button span').css('border-color', data.color);
			$('.shop-the-look-grid').css('background-color', data.color);
	    });


	    $(".prod-toggle").click(function (evt) {
	    	$(this).addClass('active').siblings().removeClass('active');

	    	if ($(this).hasClass('desc-toggle')){
	    		$('#desc').css('opacity','1').css('pointer-events','auto').siblings().css('opacity','0').css('pointer-events','none');
	    	} else if ($(this).hasClass('color-toggle')){
	    		$('#more-colors').css('opacity','1').css('pointer-events','auto').siblings().css('opacity','0').css('pointer-events','none');
	    	} else if ($(this).hasClass('size-toggle')){
	    		$('#sizing').css('opacity','1').css('pointer-events','auto').siblings().css('opacity','0').css('pointer-events','none');
	    	} else if ($(this).hasClass('ship-toggle')){
	    		$('#shipping').css('opacity','1').css('pointer-events','auto').siblings().css('opacity','0').css('pointer-events','none');
	    	}

	    	evt.preventDefault();
	    	return false;
	    });

	    if ($(window).width() < 768) {
	    	$('.slick').slick();
		}




	    // Remove Thumbnails on larger viewpoint via mouse

		$('#thumb-wrap').removeClass('active');

		var timeout = null;

		$(document).on('mousemove', function() {
		    clearTimeout(timeout);

		    $('#thumb-wrap').addClass('active');

		    timeout = setTimeout(function() {
		        $('#thumb-wrap').removeClass('active');
		    }, 750);
		});


	}


	$("#contact-handle").click(function (evt) {
		$('#contact-content').toggle();
		evt.preventDefault();
		return false;
	});


	$("#info-footer-toggle").click(function (evt) {
		$('.mobile-collapse').toggle();
		$("html, body").animate({ scrollTop: $(document).height() }, "fast");
		  return false;
		evt.preventDefault();
		return false;
	});




	$("#email_signup .close-it-modal").click(function () {
		  $(this).parent().parent().fadeOut();
		  $.cookie('UNIF_signup', 'dismissed', { expires: 30, path: '/' });
		  return false;
	});

	if ($.cookie('UNIF_signup') == null) {
      	setTimeout(function(){
    		$("#email_signup").fadeIn();
    	}, 5000);
	}

	$('.snize_widget_css').remove();
	if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1)  { 
	  body.addClass('safari');
	}



	// Klevu
	$(".search-all-btn a").click(function (evt) {
		$('#search-dialog form').submit();
		evt.preventDefault();
		return false;
	});

	function renderResponse(response) {
	  if (!response) { return; }
	  var autosuggestions = response.autoComplete,
	      cmsContent = response.pages,
	      categories = response.categpries,
	      products = response.result,
	      meta = response.meta,
	      searchedTerm = klevu_searchedTerm,
	      i, len, k = 0;

	  // Iterating through autocomplete
	  if (autosuggestions && autosuggestions.length > 0) {
	  	console.log("====================== Autosuggestions =======================");
	    var term = '', alreadyAdded = [];
	    for (i = 0, len = autosuggestions.length; i < len; i++) {
	      term = '';
	      if (autosuggestions[i].indexOf(':') !== -1) {
	        term = autosuggestions[i].split(':')[0];
	      } else {
	        term = autosuggestions[i];
	      }
	      if (alreadyAdded.indexOf(term) !== -1) {
	        continue;
	      }

	      console.log("autosuggestion to show : ", term);
	      
	      alreadyAdded[k] = term;
	      k++;
	    }
	  }

	  // Iterate through CMS content
	  if (cmsContent && cmsContent.length > 0) {
	  	console.log("====================== CMS =======================");
	    for (i = 0, len = cmsContent.length; i < len; i++) {
	      console.log("Page name to show : ", cmsContent[i].name);
	      console.log("Redirect URL on click of page name : ", cmsContent[i].url);
	    }
	  }

	  // Iterate through Categories
	  if (categories && categories.length > 0) {
	  	console.log("====================== Categories =======================");
	    for (i = 0, len = categories.length; i < len; i++) {
	      console.log("Category to show : ", categories[i].name);
	      console.log("Redirect URL on click of category : ", categories[i].url);
	    }
	  }

	  // Iterate through products
	  if (products && products.length > 0) {

	  	console.log("====================== Products =======================");
	    var productPosition = 0;
	    console.log("total results found : ", meta.totalResultsFound);
	    console.log("search results found for : ", searchedTerm);
	    $('.search-all-btn').show();
	    for (i = 0, len = products.length; i < len; i++ ){
	      productPosition = i + 1;
	      console.log("Product ID : ", products[i].id);
	      console.log("Product Name : ", products[i].name);
	      console.log("Product URL : ", products[i].url);
	      console.log("Product Image : ", products[i].imageUrl);
	      console.log("Original Price : ", products[i].price);
	      console.log("Sale Price : ", products[i].salePrice);
	      console.log("Currency : ", products[i].currency);
	      console.log("Product SKU : ", products[i].sku);
	      console.log("Product rank : ", productPosition);
	      console.log("--------------------------");

	      $('#search-results-live').append('<div class="grid__item one-half large--one-third"><a href="'+products[i].url+'"><img src="'+products[i].imageUrl+'"/><h3>'+products[i].name+'</h3></a></div>')

	    }
	  } else {
	  	$('.search-all-btn').hide();
	  }
	}

	function searchCall(keyterm) {
	  // Make the search API call with relevant parameters to get the response in JSON format.
	  var url = "//uscs7.ksearchnet.com/cloud-search/n-search/search?ticket=klevu-15271916980537979&term="+keyterm+"&paginationStartsFrom=0&klevuShowOutOfStockProducts=true&noOfResults=5&klevuSort=rel&layoutVersion=1.0&autoComplete=true&sv=1217&lsqt=&responseType=json&resultForZero=1";
	  
	  $.ajax({
		  url: url,
		  method: "POST"
		}).done(function(response) {
		  if (response) {
	      renderResponse(response);  
		  } else {
		  	console.log("invalid response");
		  }
		});	  
	}


	var typingTimer;
	var doneTypingInterval = 500;
	var $input = $('#search-dialog #search');

	$input.keyup(function(e) {

		clearTimeout(typingTimer);
		typingTimer = setTimeout(doneTyping, doneTypingInterval);


	});

	//on keydown, clear the countdown 
	
	$input.on('keydown', function () {
	  clearTimeout(typingTimer);
	});

	//user is "finished typing," do something

	function doneTyping () {
	  	$("#search-results-live").empty();
	  	var searchTerm = $input.val();
	  	searchCall(searchTerm);		
	}
  
  
  $('.klaviyo-hookup').each(function(i){
		if ($(this).isInViewport()) {
			$('#k_id_email').focus();
		}
	});

	$(window).on('resize scroll', function() {
		$('.klaviyo-hookup').each(function(i){
			if ($(this).isInViewport()) {
				$('#k_id_email').focus();
			}
		});
	});

	if ($.cookie('UNIF_signupbanner') == null) {

      	setTimeout(function(){
    		$('.klaviyo-hookup').css('display','table');
    	}, 1000);

	}


});